<div class="relative licenceView">
  <ng-container *ngIf="paymentIntegration">
    
  <!-- licence decrease waiting -->
    <div class="my-3 w-5/5 mx-auto"
      *ngIf="isDecreaseProcessing()">
      <div class="flex flex-row bg-[#DAFF00] h-12 rounded-t-md">
        <div class="basis-1/2 flex flex-row items-center px-5 font-medium">
          Lizenzanpassung zum {{tenantLicenceRequests[0]?.paymentProviderFulfillmentDateTime | date:'dd.MM.yyyy'}} vorgemerkt
        </div>
        <div class="basis-1/2 flex flex-row justify-end items-center">
        </div>
      </div>
      <div class="details-content">
        <div class="row flex flex-row basis-full items-center h-[53px] bg-white px-5 border-b ">
          Folgende Lizenzanpassung wurde zum {{tenantLicenceRequests[0]?.paymentProviderFulfillmentDateTime | date:'dd.MM.yyyy'}} vorgemerkt:
        </div>
        <div
          *ngFor="let request of tenantLicenceRequests"
          class="row flex flex-row basis-full items-center h-[53px] bg-white px-5 border-b ">
            <div class="flex basis-1/2 justify-start">
              <span><b>{{getLicenceType(request?.licenceType.toString())}}</b></span>
            </div>
            <div class="flex basis-1/2 justify-end pr-3">
              <span>{{getRemainig(request)}}</span>
            </div>
        </div>
        <div class="row flex flex-row basis-full items-center h-[53px] bg-white px-5 border-b ">
          <div>
            Um eine Lizenzanpassung vorzunehmen, lösche bitte die vorgemerkte Lizenzanpassung:
          </div>
          <div class="flex justify-end flex-grow">
            <nx-default-button
              [label]="'Vorgemerkte Lizenzanpassung löschen'"
              [style]="'dark'"
              (click)="deleteLicenceRequests()">
            </nx-default-button>
          </div>
        </div>
      </div>
    </div>

    <!-- licence decrease processing -->
    <div class="my-3 w-4/5 mx-auto"
      *ngIf="isIncreaseProcessing()">
      <div class="flex flex-row bg-[#DAFF00] h-12 rounded-t-md">
        <div class="basis-1/2 flex flex-row items-center px-5 font-medium">
          Lizenzanpassung in Bearbeitung...
        </div>
        <div class="basis-1/2 flex flex-row justify-end items-center">
        </div>
      </div>
      <div class="details-content">
        <div class="row flex flex-row basis-full items-center h-[53px] bg-white px-5 border-b ">
          Eine Lizenzanpassung ist in Bearbeitung. Das kann einen Moment dauern...
        </div>
      </div>
    </div>

    <nx-headline-box
      [ngClass]="{'decreasing': isDecreaseProcessing(), 'increasing': isIncreaseProcessing(), 'opacity-50': ( isIncreaseProcessing() || isDecreaseProcessing() )}"
      [label]="'Lizenzen'">
      <ng-template nxTemplate="tag">
        <ng-container *ngIf="paymentIntegration">
          <div *ngIf="!isTrial()" class="darkgray mt-[3px]">(Abrechnungsperiode: {{subscription?.startDateTime| date:'dd.MM.yyyy'}} - {{subscription?.endDateTime| date:'dd.MM.yyyy'}})</div>
          <div *ngIf="isTrial()" class="darkgray mt-[3px]">(Kostenlose Testphase bis {{subscription?.trialEndDateTime| date:'dd.MM.yyyy'}})</div>
        </ng-container>
      </ng-template>
        <ng-template nxTemplate="end">
        <nx-default-button
          *ngIf="isAdmin()"
          [label]="'Lizenzen neu berechnen'"
          [menuWithIcon]="true"
          [style]="'light'"
          class="pt-1"
          (click)="recalculateLicences()"
          [icon]="'icon-refresh'">
        </nx-default-button>
      </ng-template>
    </nx-headline-box>

    <div
      class="bg-white border-b border-gray"
      [ngClass]="{'decreasing': isDecreaseProcessing(), 'increasing': isIncreaseProcessing(), 'opacity-50': ( isIncreaseProcessing() || isDecreaseProcessing() )}">
      <div *ngFor="let item of subscription?.items; index as j">

        <div class="row flex flex-row items-center basis-full border-b px-5 py-2">
          <div class="flex basis-1/3 justify-start">
            <span><b>{{getLicenceType(item?.type?.toString())}}</b></span>
            <span class="darkgray">&nbsp;(Zugewiesen: {{item?.assigned? item?.assigned: 0}})</span>
          </div>
          <div class="basis-1/3 flex items-center  justify-end">
            <span>
              <lib-increment-decrement-input [disabled]="isIncreaseProcessing() || isDecreaseProcessing()" [value]="+item?.quantity" [step]="1" [min]="0" (counterChange)="onCounterChange($event, j)" />
            </span>&nbsp;&nbsp;&nbsp;&nbsp;
            <span>{{paymentService?.getCurrency(item?.price, item?.currency, currencyPipe)}}/{{paymentService?.getInterval(item?.interval)}}</span>
            <!-- (counterChange)="quantities[j]=$event" -->
          </div>
          <div class="basis-1/3 flex flex-col place-items-end">
            {{convertToEuro(getItemTotal(item, j))}}/{{getInterval(item)}}
          </div>
        </div>
        <div *ngIf="item?.discount" class="row flex flex-row items-center basis-full border-b px-5 py-2">
          <div class="flex basis-1/3 justify-start">
            <span class="discount">Rabatt</span>
            <span class="darkgray italic">&nbsp;({{item?.discount?.name}})</span>
          </div>
          <div class="basis-1/3 flex items-center justify-end">
            <span>-{{getItemDiscount(item)}}</span>
          </div>
          <div class="basis-1/3 flex flex-col place-items-end">
            <span>-{{convertToEuro(getItemDiscountValue(item, j))}}/{{getInterval(item)}}</span>
          </div>
        </div>
      </div>

      <!-- subscription discount is not used at all -> marcus confirmed in slack huddle on 08.7.25 -->
      <!-- <div class="row flex flex-row items-center basis-full border-b px-5 py-2" *ngIf="subscription?.discount">
        <div class="flex basis-1/3 justify-start">
          <span class="discount">Sonderrabatt</span>
          <span class="darkgray italic">&nbsp;({{subscription?.discount?.name}})</span>
        </div>
        <div class="basis-1/3 flex items-center justify-end">
          <span>-{{getSubscriptionDiscount()}}</span>
        </div>
        <div class="basis-1/3 flex flex-col place-items-end">
          {{convertToEuro(getSubscriptionDiscountValue())}}/{{getInterval(subscription?.items[0])}}
        </div>
      </div> -->

      <div class="h-[53px] row flex flex-row items-center basis-full border-b px-5 py-2">
        <div class="flex basis-1/3 justify-start">
          <span><b>Gesamt</b></span>
          <span class="darkgray">&nbsp;(zzgl. Steuer)</span>
        </div>
        <div class="basis-1/3 flex items-center justify-end">
        </div>
        <div class="basis-1/3 flex flex-col place-items-end">
          <b>{{convertToEuro(getTotalWithDiscount())}}/{{getInterval(subscription?.items[0])}}</b>
        </div>
      </div>

      <div *ngIf="isTrial()" class="h-[53px] row flex flex-row items-center basis-full border-b px-5 py-2">
        <div class="flex basis-1/3 justify-start">
          <span><b>Kostenlose Testphase</b></span>
        </div>
        <div class="basis-1/3 flex items-center justify-end">
        </div>
        <div class="basis-1/3 flex flex-col place-items-end">
          <b>0,00€/{{getInterval(subscription?.items[0])}}</b>
        </div>
      </div>

      <div class="row flex flex-row items-center basis-full px-5 py-2 confirm">
        <div class="flex basis-2/3 items-center">
          <ng-container *ngIf="isDecreasing()">
            <i class="icon icon-attention hint"></i>
            Hinweis:&nbsp;<span class="darkgray">
              Die Reduzierungen von User-Lizenzen wird erst bei der nächsten Abrechnungsperiode berücksichtigt.
            </span>
          </ng-container>
        </div>
        <div class="flex basis-1/3 justify-end place-items-end" *ngIf="!(isIncreaseProcessing() || isDecreaseProcessing())">
          <nx-default-button
            class="reject mr-2"
            [disabled]="!checkChanged()"
            [label]="'Abbrechen'"
            (click)="checkChanged() ? clear() : null">
          </nx-default-button>
          <nx-default-button
            class="confirm"
            [disabled]="!checkChanged()"
            [label]="'Bestätigen'"
            [style]="'dark'"
            (click)="checkChanged() ? update() : null">
          </nx-default-button>
        </div>
        <div class="flex basis-1/3 justify-end place-items-end" *ngIf="isIncreaseProcessing() || isDecreaseProcessing()">
          <nx-default-button
            [label]="'In Bearbeitung'"
            [style]="'dark'"
            [disabled]="true">
          </nx-default-button>
        </div>
      </div>
    </div>

    <ng-container *ngIf="isAmoutBasedPricingActive() && subscription?.amountItems && subscription?.amountItems.length > 0">
      <nx-headline-box
        class="mt-5"
        [label]="'Speicher'">
        <ng-template nxTemplate="tag">
          <ng-container *ngIf="paymentIntegration">
            <div *ngIf="!isTrial()" class="darkgray mt-[3px]">(Abrechnungsperiode: {{subscription?.startDateTime| date:'dd.MM.yyyy'}} - {{subscription?.endDateTime| date:'dd.MM.yyyy'}}, Gesamt belegt: {{countUsedAmount(subscription?.amountItems)}} {{subscription?.amountItems?.[0]?.amountUnit}})</div>
            <div *ngIf="isTrial()" class="darkgray mt-[3px]">(Kostenlose Testphase bis {{subscription?.trialEndDateTime| date:'dd.MM.yyyy'}})</div>
          </ng-container>
        </ng-template>
      </nx-headline-box>

      <div
      class="bg-white border-gray">
      <div *ngFor="let item of subscription?.amountItems; index as j">

        <div class="row flex flex-row items-center basis-full border-b px-5 py-4">
          <div class="flex basis-1/3 justify-start">
            <span><b>{{item.productName}}</b></span>
            <span class="darkgray">&nbsp;({{item.totalAmountUsed}}{{item.amountUnit}}/{{item.currentMaxAmount}}{{item.amountUnit}})</span>
          </div>
          <div class="basis-1/3 flex items-center flex-row justify-end">
            <div class="text-[rgba(0,0,0,0.38)]">
              {{item.quantity}}
            </div>
            <div class="min-w-[183px] text-end inline-block">{{paymentService?.getCurrency(item?.price, item?.currency, currencyPipe)}}/{{paymentService?.getInterval(item?.interval)}}</div>
          </div>
          <div class="basis-1/3 flex flex-col place-items-end">
            {{convertToEuro(getAmountItemTotal(item))}}/{{getInterval(item)}}
          </div>
        </div>
        <div *ngIf="item?.discount" class="row flex flex-row items-center basis-full border-b px-5 py-2">
          <div class="flex basis-1/3 justify-start">
            <span class="discount">Rabatt</span>
            <span class="darkgray italic">&nbsp;({{item?.discount?.name}})</span>
          </div>
          <div class="basis-1/3 flex items-center justify-end">
            <span>-{{getItemDiscount(item)}}</span>
          </div>
          <div class="basis-1/3 flex flex-col place-items-end">
            <span>-{{convertToEuro(getAmountItemDiscountValue(item, j))}}/{{getInterval(item)}}</span>
          </div>
        </div>
      </div>

      <!-- subscription discount is not used at all -> marcus confirmed in slack huddle on 08.7.25 -->
      <!-- <div class="row flex flex-row items-center basis-full border-b px-5 py-2" *ngIf="subscription?.discount">
        <div class="flex basis-1/3 justify-start">
          <span class="discount">Sonderrabatt</span>
          <span class="darkgray italic">&nbsp;({{subscription?.discount?.name}})</span>
        </div>
        <div class="basis-1/3 flex items-center justify-end">
          <span>-{{getSubscriptionDiscount()}}</span>
        </div>
        <div class="basis-1/3 flex flex-col place-items-end">
          {{convertToEuro(getSubscriptionDiscountValue())}}/{{getInterval(subscription?.items[0])}}
        </div>
      </div> -->

      <div class="h-[53px] row flex flex-row items-center basis-full border-b px-5 py-2">
        <div class="flex basis-1/3 justify-start">
          <span><b>Gesamt</b></span>
          <span class="darkgray">&nbsp;(zzgl. Steuer)</span>
        </div>
        <div class="basis-1/3 flex items-center justify-end">
        </div>
        <div class="basis-1/3 flex flex-col place-items-end">
          <b>{{convertToEuro(getAmountItemsTotal())}}/{{getInterval(subscription?.amountItems[0])}}</b>
        </div>
      </div>

      <div *ngIf="isTrial()" class="h-[53px] row flex flex-row items-center basis-full border-b px-5 py-2">
        <div class="flex basis-1/3 justify-start">
          <span><b>Kostenlose Testphase</b></span>
        </div>
        <div class="basis-1/3 flex items-center justify-end">
        </div>
        <div class="basis-1/3 flex flex-col place-items-end">
          <b>0,00€/{{getInterval(subscription?.amountItems[0])}}</b>
        </div>
      </div>

    </div>

    </ng-container>

  </ng-container>

  <ng-container *ngIf="!paymentIntegration" >
    <nx-headline-box
        [ngClass]="{'decreasing': isDecreaseProcessing(), 'increasing': isIncreaseProcessing(), 'opacity-50': ( isIncreaseProcessing() || isDecreaseProcessing() )}"
        [label]="'Lizenzen'">
    </nx-headline-box>

    <div class="bg-white border-b border-gray px-5 py-2">
      Zahlungsintegration für diesen Tenant nicht aktiviert.
    </div>
  </ng-container>

  <!-- Overlay and spinner -->
  <div *ngIf="loading" class="overlay">
      <p-progressSpinner
        strokeWidth="4" >
      </p-progressSpinner>
  </div>
</div>
